module.exports = __webpack_public_path__ + "static/img/idealprotein.14d5f73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/idealprotein.png
// module id = 754
// module chunks = 1